import { Box, Flex } from '@chakra-ui/react';
import { scaleOrdinal } from '@visx/scale';
import { EFF_QNT_COLORS } from '../chip-view-constant';
import { BaseLegend } from './base-legend';

interface Props {
  legendHeight: string;
  id?: string;
}

const EFF_LEGEND_COLORS = [...EFF_QNT_COLORS, '#ffffff'];
const EFF_LEGEND_LABELS = ['< 1.7', '< 1.9', '< 2.1', '< 2.3', '≥ 2.3', 'Not detected'];

export function EfficiencyLegend({ legendHeight, id }: Props) {
  const colorScale = scaleOrdinal<string, string>({ domain: EFF_LEGEND_LABELS, range: EFF_LEGEND_COLORS });

  return (
    <BaseLegend id={id} header="Efficiency" description="PCR efficiency">
      <Box
        display="flex"
        flexDirection="column"
        overflow="auto"
        marginLeft="-30px"
        paddingLeft="30px"
        height={legendHeight}
      >
        {EFF_LEGEND_LABELS.map(label => {
          const color = colorScale(label);
          return (
            <Flex key={label} alignItems="center" height="18px" paddingY="2px">
              <Box width="14px" height="14px" borderRadius="2px" marginRight="4px" backgroundColor={color} />
              <Box as="span" lineHeight="18px" whiteSpace="nowrap">
                {label}
              </Box>
            </Flex>
          );
        })}
      </Box>
    </BaseLegend>
  );
}
